import { AsyncState, loadingAsyncState, Updater } from "widgets-for-react"
import { DossierHighlightResult } from "../../../../../backendApi/generated"
import { getDossierHighlight } from "../../../sharepointPageApi/sharepointPageApi"

export type DossierBlockState = {
  highlight: AsyncState<DossierHighlightResult>
}

export const initialDossierBlockState = (dossierPageId: number | undefined, dossierName: string): DossierBlockState => ({
  highlight: loadingAsyncState(() => getDossierHighlight(dossierPageId, dossierName, 3))
})

export const dossierBlockStateUpdaters = {
  updateHighlight:
    (updater: Updater<AsyncState<DossierHighlightResult>>) =>
      (state: DossierBlockState): DossierBlockState => ({
        ...state,
        highlight: updater(state.highlight),
      })
}
